// Stage (Pulse feed + creators) on the web — read-mostly, with like/follow for signed-in members.
// Same endpoints the mobile app uses; posting, Reels, Live and Circles stay in the app for now.
import { api, qs } from "@/lib/api";

export const stageApi = {
  config: () => api("/creators/config", { auth: false }),
  feed: ({ tab = "foryou", page = 0, limit = 12, category } = {}) => api(`/pulse/feed?${qs({ tab, page, limit, category })}`),
  explore: ({ q, topic, page = 0, limit = 24 } = {}) => api(`/stage/explore?${qs({ q, topic, page, limit })}`),
  trending: () => api("/pulse/trending"),
  post: (id) => api(`/pulse/posts/${id}`),
  comments: (id, limit = 40) => api(`/pulse/posts/${id}/comments?${qs({ limit })}`),
  comment: (id, text, parent_id) => api(`/pulse/posts/${id}/comments`, { method: "POST", body: parent_id ? { text, parent_id } : { text } }),
  like: (id, on) => api(`/pulse/posts/${id}/like`, { method: on ? "POST" : "DELETE" }),
  save: (id, on) => api(`/pulse/posts/${id}/save`, { method: on ? "POST" : "DELETE" }),
  view: (ids) => api("/pulse/views", { method: "POST", body: { ids } }).catch(() => null),
  creators: (params) => api(`/creators?${qs(params)}`),
  creator: (handle) => api(`/creators/@${encodeURIComponent(handle)}`),
  creatorPosts: (handle, { section, cursor, limit = 18, media_only } = {}) =>
    api(`/creators/@${encodeURIComponent(handle)}/posts?${qs({ section, cursor, limit, media_only })}`),
  follow: (userId, on) => api(`/creators/${userId}/follow`, { method: on ? "POST" : "DELETE" }),
};

export function compact(n) {
  const v = Number(n || 0);
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 1)}M`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(v % 1_000 === 0 ? 0 : 1)}k`;
  return String(v);
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)}d`;
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  } catch {
    return "";
  }
}

// Mirrors OPEN_TO in backend/routes/creators.py (labels also arrive via /creators/config).
export const OPEN_TO_LABEL = {
  collabs: "Collabs",
  paid_promo: "Paid promo",
  podcast_guest: "Podcast guest",
  event_appearance: "Event appearance",
  feature_shoutout: "Feature / Shoutout",
  casting: "Casting",
  co_streaming: "Co-streaming",
  brand_deals: "Brand deals",
  mentoring: "Mentoring",
  not_open: "Not currently open",
};
